import React from 'react';
import {Container, Row, Col} from 'reactstrap';

import '../debtPayment.scss';
import BasicText from './basicText';
import BasicImage from './basicImage';

const Action = (props) => {
  const containerClass = `debtpayment-whitepinkbtn ${props.isPrivate ? 'privateDebtActionColors' : ''}`;
  return (
    <Container className={containerClass} onClick={() => props.onclick(props.fnParams)}>
      <Row>
        <Col xs='1'>
          <BasicImage src={props.img} />
        </Col>
        <Col xs='10'>
          <BasicText text={props.text} bold={props.bold} color={props.color ? props.color : 'businessPurple'} />
        </Col>
      </Row>
    </Container>
  );
};

export default Action;
